import { DayNightSvg } from "../../inlinesvgs/DayNightSvg";
import { I18N } from "oc-I18N";

const buttonTitle = I18N("Tag Nacht umschalten");

export function DaytimeToggle() {
  const trafoTreesLength = APP.arrangement?.trafoTrees?.length ?? 0;
  const disabled = trafoTreesLength == 0;
  const on = APP.nightMode;
  const classList = ["svg-button-dotted"];
  !disabled && classList.push("active");
  on && classList.push("on");
  return (
    <button
      className={classList.join(" ")}
      title={buttonTitle}
      aria-label={buttonTitle}
      data-button-key="daytimeToggle"
      disabled={disabled}
      onClick={() => {
        APP.toggleDaytime();
        APP.logUserAction({ action: "daytimeToggle" }, { stateChange: false });
      }}
    >
      <DayNightSvg />
    </button>
  );
}
